import styles from "../products/analytics-table.module.css"

export default function VIPAnalysis({ data }) {
  if (!data || !data.vipVsNonVip) {
    return (
      <div className={styles.tableContainer}>
        <h2>VIP vs Non-VIP Analysis</h2>
        <p style={{ color: "rgba(255, 255, 255, 0.6)" }}>No VIP data available</p>
      </div>
    )
  }

  return (
    <div className={styles.tableContainer}>
      <h2>VIP vs Non-VIP Analysis</h2>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>User Type</th>
              <th>Total Orders</th>
              <th>Total Revenue</th>
              <th>Avg Order Value</th>
              <th>Unique Users</th>
            </tr>
          </thead>
          <tbody>
            {data.vipVsNonVip.map((item, index) => (
              <tr key={index}>
                <td>{item._id.isVip ? "VIP" : "Non-VIP"}</td>
                <td>{item.totalOrders.toLocaleString()}</td>
                <td>₹{item.totalRevenue.toLocaleString()}</td>
                <td>₹{item.avgOrderValue.toFixed(2)}</td>
                <td>{item.uniqueUserCount.toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
